var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4375,
    fill: "#A3A6B3",
    stroke: "#A3A6B3",
    strokeWidth: 1.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1001 8.43738V5.43738H9.1001V9.43738H6.1001V8.43738H8.1001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31274 10.3337L3.45284 13.1587L2.45407 13.2082L2.31396 10.3833L3.31274 10.3337Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32369 10.3827L5.14864 10.2426L5.19817 11.2414L2.37322 11.3815L2.32369 10.3827Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81577 14.1315C6.03562 13.94 4.39186 12.878 3.02003 11.7631L3.65074 10.9871C4.99119 12.0765 6.44444 12.9782 7.92275 13.1373C9.34642 13.2904 10.8991 12.7635 12.4952 10.7446L13.2797 11.3648C11.5177 13.5935 9.65056 14.3289 7.81577 14.1315Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6615 5.851L12.5214 3.02605L13.5202 2.97651L13.6603 5.80147L12.6615 5.851Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6506 5.80202L10.8256 5.94212L10.7761 4.94335L13.601 4.80325L13.6506 5.80202Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1585 2.05322C9.93864 2.24476 11.5824 3.30669 12.9542 4.42163L12.3235 5.19765C10.9831 4.10821 9.52983 3.20654 8.05152 3.04748C6.62785 2.8943 5.07512 3.42126 3.47904 5.44015L2.69458 4.81998C4.45654 2.59125 6.32371 1.85581 8.1585 2.05322Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWaiting);
export default __webpack_public_path__ + "static/media/icn_waiting.13a2e835.svg";
export { ForwardRef as ReactComponent };